module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUAQMAAADFiO34AAAABlBMVEWGFiP///8wFwrqAAAAEklEQVQI12NgIBH8BwEsJIkAAKwEE+3AWvguAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/lv.png
// module id = 875
// module chunks = 0